import styled from 'styled-components'

export const Main = styled.main`
  max-width: ${props => props.mobile ? '100%' : '367px'};
  max-height: ${props => props.mobile ? '100vh' : '432px'};
  height: ${props => props.mobile ? '100vh' : '432px'};
  border-radius: ${props => props.mobile ? '0' : '8px'};
  overflow: ${props => props.mobile ? 'none' : 'hidden'};
`

export const Title = styled.p`
  color: ${props => props.theme.box.text};
`

export const InnerContainer = styled.div`
  /* padding: 16px 18px 30px 25px; */
  background: ${props => props.theme.box.background};
  padding: 16px 34px 30px 25px;
  height: ${props => props.mobile ? '85vh' : '350px'};
`
export const ChatContainer = styled.div`
  overflow-y:auto;
  overflow-x: hidden;
  max-height: ${props => props.mobile ? '100%' : '360px'};
  margin-right: -18px;
  position: relative;

  &::-webkit-scrollbar {
    width: 16px;
  }

  &::-webkit-scrollbar-track {
    background: ${props => props.theme.box.background};
    /* border: 1px solid rgba(22,22,22,.12); */
    z-index: 100;
    position:relative;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(22,22,22,.12);
    border-radius: 8px;
    border: 4px solid #fff;
    z-index: -1;
    position:relative;
  }
`

export const ChatInit = styled.div`
  height: ${props => props.mobile ? '55vh' : '150px'};
`